{
  "cycle.entite.programme_derogations_ecart": "Programme waivers to keep a technology deviation",
  "journalAudit.action.program.technologies_inherited": "Programme: all technologies inherited from the organisation",
  "journalAudit.action.program.technology_deviation_kept": "Programme: technology deviation kept under a waiver",
  "journalAudit.action.program.technology_change_decided": "Programme: technology change decided",
  "journalAudit.action.program.deviation_waiver_requested": "Programme: waiver to keep the deviation requested"
}
